import {
  BOOKS_BOOK_AUTHORS_SET_DATA,
  BOOKS_BOOK_AUTHORS_RESET_DATA,
} from 'rebook/apps/books/constants';


const initialState = {
  book: null,
};

export default function bookAuthorList(state = initialState, action) {
  switch (action.type) {
    case BOOKS_BOOK_AUTHORS_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case BOOKS_BOOK_AUTHORS_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
